import axios from 'axios';

import AuthStore from 'stores/AuthStore'
import QualCodeActions from 'actions/QualCodeActions'
import ErrorActions from 'actions/ErrorActions';
import {
  HTTPError
} from './HTTPErrors'


function _is401Error(error) {
  return error.response && error.response.status === 401;
}

function _basicErrorHandler(error)
{
  error = error || {};
  let response = error.response || {};

  if ( response.status == 401)
  {
    // Only dispatch a sign-out if we actually hold a session. A 401 for an
    // unauthenticated visitor (e.g. useCurrentUser firing on the sign_in
    // page) is the expected answer, and dispatching signOut here resets the
    // store to InitialState — wiping login error messages mid-render.
    if ( AuthStore.isLoggedIn() )
      QualCodeActions.signOut();
  }
  else if (response.headers) {
    AuthStore.updateToken(response.headers);
  }

  const NETWORK_ERROR = 'Network Error';
  if ( error.message === NETWORK_ERROR )
    ErrorActions.networkError(error);

  const httpError = HTTPError.createHTTPError(error);
  if ( !!httpError ) throw httpError;

  throw error;
}

function _axiosRequest(method, endpoint, data = null, retryCount = 0, extraHeaders = null) {
  const authHeader = AuthStore.getHeader();
  const config = {
    method: method,
    url: endpoint,
    ...authHeader,
  };
  if (extraHeaders) {
    config.headers = { ...(authHeader && authHeader.headers), ...extraHeaders };
  }

  if (data) {
    config.data = data;
  }

  return axios(config)
    .then(response => {
      AuthStore.updateToken(response.headers);
      return response;
    })
    .catch(error => {
      if (_is401Error(error) && retryCount > 0 && !!AuthStore.getHeader()?.headers) {

        // Calculate exponential delay
        const delay = 1000;
        const exponentialDelay = delay * Math.pow(2, 3 - retryCount);
        // Add jitter (randomness)
        const jitter = Math.random() * 0.3 * exponentialDelay;
        const finalDelay = exponentialDelay + jitter;

        console.log(`Retrying request, ${retryCount} attempts left..., retrying in ${finalDelay}ms`);

        // Here you can also introduce a delay before retrying, especially if you suspect it's a race condition.
        return new Promise(resolve => setTimeout(() => resolve(), finalDelay))
          .then(() => _axiosRequest(method, endpoint, data, retryCount - 1, extraHeaders));
      } else {
        _basicErrorHandler(error);
      }
    });
}

function _get(endpoint, extraHeaders = null) {
  return _axiosRequest('get', endpoint, null, 3, extraHeaders);
}

function _post(endpoint, body, extraHeaders = null) {
  return _axiosRequest('post', endpoint, body, 3, extraHeaders);
}

function _put(endpoint, body, extraHeaders = null) {
  return _axiosRequest('put', endpoint, body, 3, extraHeaders);
}

function _patch(endpoint, body, extraHeaders = null) {
  return _axiosRequest('patch', endpoint, body, 3, extraHeaders);
}

function _delete(endpoint, body, extraHeaders = null) {
  return _axiosRequest('delete', endpoint, body, 3, extraHeaders);
}


var API = {
  get: _get,
  delete: _delete,
  put: _put,
  post: _post,
  patch: _patch,
};


export default API
